import { render, staticRenderFns } from "./CommentsPreviewBody.vue?vue&type=template&id=10db9c78&scoped=true&"
import script from "./CommentsPreviewBody.vue?vue&type=script&lang=js&"
export * from "./CommentsPreviewBody.vue?vue&type=script&lang=js&"
import style0 from "./CommentsPreviewBody.vue?vue&type=style&index=0&id=10db9c78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10db9c78",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10db9c78')) {
      api.createRecord('10db9c78', component.options)
    } else {
      api.reload('10db9c78', component.options)
    }
    module.hot.accept("./CommentsPreviewBody.vue?vue&type=template&id=10db9c78&scoped=true&", function () {
      api.rerender('10db9c78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenantProjects/submissions/CommentsPreviewBody.vue"
export default component.exports